import React, { useState, useEffect } from "react";
import api from "../../../../api";
import "./ValueAddedCourse.css";
import DynamicBanner from "../../include/DynamicBanner";

const toArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [val];
};

const ValueAddedCourse = () => {
  const [courses, setCourses] = useState([]);
  const [showAllRows, setShowAllRows] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const [banner, setBanner] = useState({
  title: "",
  images: [],
  mobile_images: [],
});

  const [sectionHeadingHtml, setSectionHeadingHtml] = useState("");
  const initialVisible = 10;

  useEffect(() => {
    let cancelled = false;

    const fetchCourses = async () => {
      try {
        setLoading(true);
        const res = await api.get("/api/sitepages/about-us/value-added");
        const data = res.data || {};

        const bannerData = data.banner_data ||
          (Array.isArray(data.groups) && data.groups.find((g) => g.banner_section)?.banner_section) ||
          {};

       const normalizedBanner = {
  title:
    bannerData.title ||
    bannerData.heading ||
    data.banner_data?.title ||
    "",
  images: toArray(bannerData.images || data.banner_data?.images),
  mobile_images: toArray(
    bannerData.mobile_images || data.banner_data?.mobile_images
  ),
};


        const courseSection =
          data.course_section ||
          (Array.isArray(data.groups) && data.groups.find((g) => g.course_section)?.course_section) ||
          {};

        const fetchedCourses = Array.isArray(courseSection.courses) ? courseSection.courses : [];

        if (!cancelled) {
          setBanner(normalizedBanner);
          setCourses(fetchedCourses);
          setSectionHeadingHtml(courseSection.heading || "");
          setError(null);
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        if (!cancelled) setError("Failed to load courses");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchCourses();
    return () => {
      cancelled = true;
    };
  }, []);

  const toggleRows = () => setShowAllRows(!showAllRows);

  const visibleCourses = showAllRows ? courses : courses.slice(0, initialVisible);

  return (
    <>
     <DynamicBanner
  title={banner.title}
  bgImage={banner.images}
  bgImageMobile={banner.mobile_images}
/>


      <section>
        <div className="container">
          <div className="row">
            <div className="sec-title text-center">
              <h2
                dangerouslySetInnerHTML={{
                  __html:
                    sectionHeadingHtml ||
                    "Value-added Courses Offered During The Last Five Years<br/>That Impart Transferable and Life Skills",
                }}
              />
            </div>

            {loading && <p>Loading courses...</p>}
            {error && <p className="text-danger">{error}</p>}

            {!loading && !error && (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Course Name</th>
                      <th>Course Code</th>
                      <th>Year of offering</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleCourses.map((course, idx) => {
                      const globalIndex = courses.findIndex((c) => c === course);
                      return (
                        <tr key={course.id || `${globalIndex}-${idx}`}>
                          <td>{globalIndex + 1}</td>
                          <td>{course.name}</td>
                          <td>{course.code}</td>
                          <td>{course.year}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {courses.length > initialVisible && (
                  <div className="text-center mt-3">
                    <button onClick={toggleRows} className=" btn-maintanence mb-5">
                      {showAllRows ? "Read Less" : "Read More"}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ValueAddedCourse;
